// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import Spinner, { SpinnerColor } from '../Spinner';

export interface IProps {
  title?: string;
  className: string;
  onClick?: (e?: any) => void;
  childElement?: React.ReactNode;
  isLoading?: boolean;
  isSuccess?: boolean;
  key?: string;
  disable?: boolean;
  uiDisabled?: boolean;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  shouldInvertLoaderColor?: boolean;
  submitButtonSpinnerColor?: SpinnerColor;
  id: string;
  testId?: string;
  ref?: any;
  btnType?: string;
  preIcon?: React.ReactNode;
  postIcon?: React.ReactNode;
  avoidStopPropagation?: boolean;
}

const Button = ({
  title, className, onClick, childElement, isLoading, key, disable, isSuccess, handleMouseEnter, handleMouseLeave, id, shouldInvertLoaderColor, submitButtonSpinnerColor, testId, ref, btnType, uiDisabled, preIcon, avoidStopPropagation, postIcon: postIcom,
}: IProps) => {
  const DEFAULT_BUTTON_HEIGHT = 53;
  const innerRef = useRef<HTMLButtonElement>(null);
  const cb = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isLoading) return;
    e.preventDefault();
    if (!avoidStopPropagation) {
      e.stopPropagation();
    }
    if (onClick) onClick(e);
  };

  useEffect(() => {
    if (isLoading !== undefined) {
      if (innerRef?.current) {
        // eslint-disable-next-line prefer-const
        let { width, height } = innerRef.current.getBoundingClientRect();
        if (height < DEFAULT_BUTTON_HEIGHT) height = DEFAULT_BUTTON_HEIGHT;
        innerRef.current.style.minWidth = `${width}px`;
        innerRef.current.style.maxWidth = `${width}px`;
        innerRef.current.style.minHeight = `${height}px`;
        innerRef.current.style.maxHeight = `${height}px`;
      } else if (ref?.current) {
        // eslint-disable-next-line prefer-const
        let { width, height } = ref.current.getBoundingClientRect();
        if (height < DEFAULT_BUTTON_HEIGHT) height = DEFAULT_BUTTON_HEIGHT;
        ref.current.style.minWidth = `${width}px`;
        ref.current.style.maxWidth = `${width}px`;
        ref.current.style.minHeight = `${height}px`;
        ref.current.style.maxHeight = `${height}px`;
      }
    }
  }, [innerRef?.current, ref?.current, title]);

  return (
    <button
      ref={ref || innerRef}
      id={id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      key={key ? `${key}` : 'key'}
      onClick={(e) => cb(e)}
      className={`${className}`}
      style={disable ? { cursor: 'default' } : { cursor: 'pointer' }}
      /* eslint-disable-next-line react/button-has-type */
      type={btnType || 'button'}
      disabled={!!disable}
      data-testid={testId}
      data-uidisabled={uiDisabled}
    >
      {!isLoading && preIcon && <div>{preIcon}</div>}
      {(isLoading || isSuccess) ? <Spinner spinnerColor={submitButtonSpinnerColor || (shouldInvertLoaderColor ? SpinnerColor.Blue : SpinnerColor.White)} height='2rem' width='2rem' /> : title}
      {(childElement && !isLoading) && childElement}
      {!isLoading && postIcom && <div>{postIcom}</div>}
    </button>
  );
};

export default Button;
